import { render, staticRenderFns } from "./StatusTimeline.vue?vue&type=template&id=28178ffc&scoped=true"
import script from "./StatusTimeline.vue?vue&type=script&lang=js"
export * from "./StatusTimeline.vue?vue&type=script&lang=js"
import style0 from "./StatusTimeline.vue?vue&type=style&index=0&id=28178ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28178ffc",
  null
  
)

export default component.exports